export function SettingsPage() {
  return (
    <div>
      <h1 className="mb-6 text-3xl font-bold">Settings</h1>

      <div className="rounded-lg border bg-white p-8">
        <p className="text-muted-foreground">Account settings will be implemented here.</p>
      </div>
    </div>
  );
}
